export const isGreaterThan = (n) => (value) => {
  if (!isNaN(value) && +value <= +n) {
    return `Value should be greater than ${n}`;
  }
  return undefined;
};

export default isGreaterThan;
